<template>
  <button
    class="modal-button-close"
    :class="[this.$route.params.lang]"
    v-html="$t('btn.close')"
    @click="$emit('click')"
  />
</template>

<script>
import localeCommon from '@locales/common'

export default {
  $messages: localeCommon,
}
</script>

<style lang="scss" scoped>
.modal-button-close {
  position: absolute;
  width: 108px;
  height: 112px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  z-index: 1;
  @include tap-event();
  @include hidden-text();
  &.ja-JP {
    background-image: url(#{$img-path}modal/ja-JP/btn_modal-close.png);
  }
  &.de-DE {
    background-image: url(#{$img-path}modal/de-DE/btn_modal-close.png);
  }
  &.en-GB {
    background-image: url(#{$img-path}modal/en-GB/btn_modal-close.png);
  }
  &.en-US {
    background-image: url(#{$img-path}modal/en-US/btn_modal-close.png);
  }
  &.es-ES {
    background-image: url(#{$img-path}modal/es-ES/btn_modal-close.png);
  }
  &.es-MX {
    background-image: url(#{$img-path}modal/es-MX/btn_modal-close.png);
  }
  &.fr-CA {
    background-image: url(#{$img-path}modal/fr-CA/btn_modal-close.png);
  }
  &.fr-FR {
    background-image: url(#{$img-path}modal/fr-FR/btn_modal-close.png);
  }
  &.it-IT {
    background-image: url(#{$img-path}modal/it-IT/btn_modal-close.png);
  }
  &.pt-BR {
    background-image: url(#{$img-path}modal/pt-BR/btn_modal-close.png);
  }
  &.zh-TW {
    background-image: url(#{$img-path}modal/zh-TW/btn_modal-close.png);
  }
}
</style>
